import _inherits from "D:\\a\\1\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _setPrototypeOf from "D:\\a\\1\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/setPrototypeOf";
function _wrapRegExp() { _wrapRegExp = function _wrapRegExp(e, r) { return new BabelRegExp(e, void 0, r); }; var e = RegExp.prototype, r = new WeakMap(); function BabelRegExp(e, t, p) { var o = RegExp(e, t); return r.set(o, p || r.get(e)), _setPrototypeOf(o, BabelRegExp.prototype); } function buildGroups(e, t) { var p = r.get(t); return Object.keys(p).reduce(function (r, t) { var o = p[t]; if ("number" == typeof o) r[t] = e[o];else { for (var i = 0; void 0 === e[o[i]] && i + 1 < o.length;) i++; r[t] = e[o[i]]; } return r; }, Object.create(null)); } return _inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function (r) { var t = e.exec.call(this, r); if (t) { t.groups = buildGroups(t, this); var p = t.indices; p && (p.groups = buildGroups(p, this)); } return t; }, BabelRegExp.prototype[Symbol.replace] = function (t, p) { if ("string" == typeof p) { var o = r.get(this); return e[Symbol.replace].call(this, t, p.replace(/\$<([^>]+)(>|$)/g, function (e, r, t) { if ("" === t) return e; var p = o[r]; return Array.isArray(p) ? "$" + p.join("$") : "number" == typeof p ? "$" + p : ""; })); } if ("function" == typeof p) { var i = this; return e[Symbol.replace].call(this, t, function () { var e = arguments; return "object" != typeof e[e.length - 1] && (e = [].slice.call(e)).push(buildGroups(e, i)), p.apply(this, e); }); } return e[Symbol.replace].call(this, t, p); }, _wrapRegExp.apply(this, arguments); }
import _padStartInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/pad-start";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import { DATA_TYPE_OBJECT, DATA_TYPE_DATE_TIME } from '@jutro/prop-types';
import isString from "lodash/isString";
import isNumber from "lodash/isNumber";
import isDate from "lodash/isDate";
import { format, isEqual, isAfter, isBefore } from 'date-fns';
const SAMPLE_DATE = {
  YEAR: '1970',
  MONTH: '01',
  DAY: '15'
};
const PATTERN_MAP = {
  YEAR: 'yyyy',
  MONTH: 'MM',
  DAY: 'dd'
};
const SEPARATORS = ['/', '-', '.'];
const DDMMYYYY = /*#__PURE__*/_wrapRegExp(/^(\d{1,2})[/\-.](\d{1,2})[/\-.](\d{1,4})(.*)$/, {
  d: 1,
  m: 2,
  y: 3,
  t: 4
});
const MMDDYYYY = /*#__PURE__*/_wrapRegExp(/^(\d{1,2})[/\-.](\d{1,2})[/\-.](\d{1,4})(.*)$/, {
  m: 1,
  d: 2,
  y: 3,
  t: 4
});
const YYYYMMDD = /*#__PURE__*/_wrapRegExp(/^(\d{1,4})[/\-.](\d{1,2})[/\-.](\d{1,2})(.*)$/, {
  y: 1,
  m: 2,
  d: 3,
  t: 4
});
export function formatDateToDataType(date, dataType, includeTime = false) {
  const year = date.getTimezoneOffset() < 0 ? date.getFullYear() : date.getUTCFullYear();
  const month = date.getTimezoneOffset() < 0 ? date.getMonth() : date.getUTCMonth();
  const day = date.getTimezoneOffset() < 0 ? date.getDate() : date.getUTCDate();
  const hour = date.getTimezoneOffset() < 0 ? date.getHours() : date.getUTCHours();
  const minute = date.getTimezoneOffset() < 0 ? date.getMinutes() : date.getUTCMinutes();
  if (dataType === DATA_TYPE_OBJECT) {
    return includeTime ? {
      year,
      month,
      day,
      hour,
      minute
    } : {
      year,
      month,
      day
    };
  }
  if (includeTime) {
    return new Date(Date.UTC(year, month, day, hour, minute)).toISOString();
  }
  const dateString = new Date(Date.UTC(year, month, day)).toISOString();
  return dataType === DATA_TYPE_DATE_TIME ? dateString : dateString.substr(0, 10);
}
export function parseDateShapeToDate(value, includeTime = false) {
  if (isString(value) || isNumber(value) || isDate(value)) {
    const date = new Date(value);
    const _ref = [date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()],
      year = _ref[0],
      month = _ref[1],
      day = _ref[2];
    return includeTime ? date : new Date(year, month, day);
  }
  if (includeTime) {
    const year = value.year,
      month = value.month,
      day = value.day,
      _value$hour = value.hour,
      hour = _value$hour === void 0 ? 0 : _value$hour,
      _value$minute = value.minute,
      minute = _value$minute === void 0 ? 0 : _value$minute;
    return new Date(year, month, day, hour, minute);
  }
  const year = value.year,
    month = value.month,
    day = value.day;
  return new Date(year, month, day);
}
export function isDateShapeInRange(dateShape, minDateShape, maxDateShape) {
  const date = parseDateShapeToDate(dateShape);
  const minDateObject = minDateShape ? parseDateShapeToDate(minDateShape) : null;
  const maxDateObject = maxDateShape ? parseDateShapeToDate(maxDateShape) : null;
  const meetsMinRequirement = !minDateObject || isEqual(date, minDateObject) || isAfter(date, minDateObject);
  const meetsMaxRequirement = !maxDateObject || isEqual(date, maxDateObject) || isBefore(date, maxDateObject);
  return meetsMinRequirement && meetsMaxRequirement;
}
export function getPatternFromLocale(locale) {
  const sampleDate = new Date(`${SAMPLE_DATE.YEAR}-${SAMPLE_DATE.MONTH}-${SAMPLE_DATE.DAY}T00:00`);
  const pattern = format(sampleDate, 'P', {
    locale
  });
  return pattern.replace(SAMPLE_DATE.YEAR, PATTERN_MAP.YEAR).replace(SAMPLE_DATE.MONTH, PATTERN_MAP.MONTH).replace(SAMPLE_DATE.DAY, PATTERN_MAP.DAY);
}
export function getInputDateFormats(pattern) {
  const dateFormats = _mapInstanceProperty(SEPARATORS).call(SEPARATORS, separator => {
    return pattern.replace(/[/\-.]/g, separator);
  });
  dateFormats.push('P');
  return dateFormats;
}
export function normalizeInput(input, datePattern) {
  var _match$groups, _match$groups2, _context, _match$groups3, _context2, _match$groups$t, _match$groups4;
  const getPattern = () => {
    switch (datePattern.charAt(0).toLowerCase()) {
      case 'd':
        return DDMMYYYY;
      case 'm':
        return MMDDYYYY;
      case 'y':
        return YYYYMMDD;
      default:
        break;
    }
    return DDMMYYYY;
  };
  const match = input.match(getPattern());
  if (!match) {
    return input;
  }
  const year = match === null || match === void 0 ? void 0 : (_match$groups = match.groups) === null || _match$groups === void 0 ? void 0 : _match$groups.y;
  const month = match === null || match === void 0 ? void 0 : (_match$groups2 = match.groups) === null || _match$groups2 === void 0 ? void 0 : _padStartInstanceProperty(_context = _match$groups2.m).call(_context, 2, '0');
  const day = match === null || match === void 0 ? void 0 : (_match$groups3 = match.groups) === null || _match$groups3 === void 0 ? void 0 : _padStartInstanceProperty(_context2 = _match$groups3.d).call(_context2, 2, '0');
  return `${year}-${month}-${day}${(_match$groups$t = match === null || match === void 0 ? void 0 : (_match$groups4 = match.groups) === null || _match$groups4 === void 0 ? void 0 : _match$groups4.t) !== null && _match$groups$t !== void 0 ? _match$groups$t : ''}`;
}